const rankingItems = [
  {
    rank: 1,
    title: '某顶流男星深夜密会视频完整版曝光',
    tag: '明星绯闻',
    heat: '🔥 32.6万热度',
    update: '10分钟前',
  },
  {
    rank: 2,
    title: '知名女星被曝税务问题，工作室紧急发声明',
    tag: '实锤吃瓜',
    heat: '28.1万热度',
    update: '1小时前',
  },
  {
    rank: 3,
    title: '两大经纪公司正面交锋：艺人合约纠纷升级',
    tag: '娱乐圈内幕',
    heat: '23.5万热度',
    update: '2小时前',
  },
  {
    rank: 4,
    title: '热门综艺录制现场发生意外，当事人已送医',
    tag: '最新爆料',
    heat: '19.8万热度',
    update: '3小时前',
  },
  {
    rank: 5,
    title: '国际品牌中国区代言人换届，新面孔引热议',
    tag: '商业八卦',
    heat: '16.2万热度',
    update: '5小时前',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="relative py-20 md:py-28 px-4 md:px-8 bg-background-100/50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-accent-500/10 text-accent-400 text-xs font-semibold rounded-full border border-accent-500/20 whitespace-nowrap mb-4">
            <i className="ri-bar-chart-2-line text-[10px]"></i>
            热度榜单
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 tracking-tight">
            实时 <span className="font-heading italic text-accent-400">爆料热度榜</span>
          </h2>
          <p className="text-foreground-400 text-sm mt-3 max-w-lg mx-auto">
            根据阅读量、讨论度和分享数综合计算，实时更新最火爆的爆料内容
          </p>
        </div>

        <div className="rounded-2xl bg-background-50 border border-background-200/50 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className={`flex items-center gap-4 md:gap-6 px-5 md:px-8 py-4 md:py-5 transition-colors hover:bg-accent-500/5 cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/30' : ''
              } ${item.rank === 1 ? 'bg-accent-500/[0.03]' : ''}`}
            >
              <span
                className={`flex-shrink-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-xl text-sm font-extrabold ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-950'
                    : item.rank === 2
                    ? 'bg-accent-500/20 text-accent-400'
                    : item.rank === 3
                    ? 'bg-accent-500/10 text-accent-400'
                    : 'bg-background-100 text-foreground-500'
                }`}
              >
                {item.rank}
              </span>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="inline-flex px-2 py-0.5 bg-secondary-100 text-secondary-400 text-[10px] font-semibold rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-[10px] text-foreground-600 whitespace-nowrap">{item.update}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 truncate">
                  {item.title}
                </h3>
              </div>

              <div className="flex-shrink-0 text-xs font-medium text-accent-400 whitespace-nowrap">
                {item.heat}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}